module.exports = __webpack_public_path__ + "images/emoji/mount_fuji.a53307a1a7e2530671c9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mount_fuji.png
// module id = 87ls
// module chunks = 1